<div class="container">
    <header>
        <div class="controls">
            <!-- Loading indicator while detecting file type -->
            <ng-container *ngIf="isDetectingType">
                <span class="detecting-type">Detecting file type...</span>
            </ng-container>

            <!-- Shared controls for both images and PDFs -->
            <ng-container *ngIf="!isDetectingType && showControls()">
                <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= minZoom || pdfLoadError" matTooltip="Zoom Out">
                    <mat-icon>zoom_out</mat-icon>
                </button>
                <button mat-icon-button (click)="resetZoom()" [disabled]="pdfLoadError" matTooltip="Reset Zoom">
                    <span class="zoom-level">{{ (zoomLevel * 100) | number: '1.0-0' }}%</span>
                </button>
                <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= maxZoom || pdfLoadError" matTooltip="Zoom In">
                    <mat-icon>zoom_in</mat-icon>
                </button>
                <span class="divider"></span>
                <button mat-icon-button (click)="rotateLeft()" [disabled]="pdfLoadError" matTooltip="Rotate Left">
                    <mat-icon>rotate_left</mat-icon>
                </button>
                <button mat-icon-button (click)="rotateRight()" [disabled]="pdfLoadError" matTooltip="Rotate Right">
                    <mat-icon>rotate_right</mat-icon>
                </button>
            </ng-container>

            <!-- PDF page navigation - show when loaded successfully -->
            <ng-container *ngIf="isPdf() && !pdfLoadError && totalPages > 1">
                <span class="divider"></span>
                <button mat-icon-button (click)="previousPage()" [disabled]="currentPage <= 1" matTooltip="Previous Page">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <span class="page-indicator">{{ currentPage }} / {{ totalPages }}</span>
                <button mat-icon-button (click)="nextPage()" [disabled]="currentPage >= totalPages" matTooltip="Next Page">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </ng-container>
        </div>
        <button mat-icon-button (click)="close()" class="close-button" matTooltip="Close">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="content">
        <!-- Loading indicator while detecting file type -->
        <div *ngIf="isDetectingType" class="loading-container">
            <mat-spinner diameter="48"></mat-spinner>
            <span>Loading document...</span>
        </div>

        <!-- Image viewer with transform controls -->
        <div *ngIf="!isDetectingType && isImage()"
             class="image-container"
             [class.drag-mode]="isDragMode"
             (mousedown)="onMouseDown($event)"
             (mousemove)="onMouseMove($event)"
             (mouseup)="onMouseUp()"
             (mouseleave)="onMouseUp()">
            <img [src]="detectedImageUrl || data.src"
                 [style.transform]="getTransform()"
                 [style.left.px]="panX"
                 [style.top.px]="panY"
                 alt="Document preview"
                 draggable="false" />
        </div>

        <!-- PDF viewer rendered to canvas with same controls as images -->
        <div *ngIf="!isDetectingType && isPdf() && !pdfLoadError"
             class="pdf-container"
             [class.drag-mode]="isDragMode && !pdfLoading"
             (mousedown)="onMouseDown($event)"
             (mousemove)="onMouseMove($event)"
             (mouseup)="onMouseUp()"
             (mouseleave)="onMouseUp()">
            <!-- Loading indicator -->
            <div *ngIf="pdfLoading" class="pdf-loading">
                <mat-spinner diameter="48"></mat-spinner>
                <span>Loading PDF...</span>
            </div>
            <!-- PDF canvas -->
            <canvas #pdfCanvas
                    [style.transform]="getTransform()"
                    [style.left.px]="panX"
                    [style.top.px]="panY"
                    [class.hidden]="pdfLoading"></canvas>
        </div>

        <!-- Fallback iframe for PDFs that fail to load with canvas -->
        <div *ngIf="!isDetectingType && isPdf() && pdfLoadError" class="pdf-fallback-container">
            <div class="pdf-error-message">
                <mat-icon>warning</mat-icon>
                <span>PDF preview not available. Opening in browser viewer.</span>
            </div>
            <iframe [src]="getSafeUrl(data.src)" class="pdf-iframe" title="PDF document viewer"></iframe>
        </div>

        <!-- Fallback iframe for unknown document types -->
        <iframe *ngIf="!isDetectingType && detectedFileType === 'unknown'" [src]="getSafeUrl(data.src)" title="Document viewer"></iframe>
    </div>
</div>
